import {GetterTree} from 'vuex';
import {RootState} from '@/store';
import {FeatureFlag} from "@/models/response/BrainpowerApiResponse";
import {ConfigState} from "@/store/modules/config/index";

export const getters: GetterTree<ConfigState, RootState> = {

    featureFlags(state): FeatureFlag {
        return state.featureFlags
    }
}
